/**
 * navModel.ts — pure nav logic for the two-section sidebar (§14.B/C).
 *
 * The active department is DERIVED from the route, never stored: the flat
 * dept switcher and the Workspace list both read this one function, so the
 * highlight cannot desync from activePage. Item ids are unique across
 * departments (route strings like 'sales.dashboard'), which makes the
 * derivation unambiguous; deep drill-ins (Deal Detail, Lead Detail) keep
 * their parent item id in activePage, so they resolve to the same
 * department. Dept-less routes (overview.home, settings.company) resolve to
 * null — no card active, Workspace hidden.
 */
export interface NavDepartment {
  id: string
  items: { id: string }[]
}

export function activeDepartment<T extends NavDepartment>(
  departments: T[],
  activePage: string,
): T | null {
  return departments.find((d) => d.items.some((i) => i.id === activePage)) ?? null
}
